module.exports = __webpack_public_path__ + "img/logo.346d9939.svg";